import { render, staticRenderFns } from "./dashboard-body.vue?vue&type=template&id=6f3374f2"
import script from "./dashboard-body.vue?vue&type=script&lang=js"
export * from "./dashboard-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports